import request from '@/utils/request'

export function pageLiveCourseSection(data) {
  return request({
    url: '/livecourse/liveCourseSection/page',
    method: 'post',
    data: data
  })
}

export function listLiveCourseSection(query) {
  return request({
    url: '/livecourse/liveCourseSection/list',
    method: 'get',
    params: query
  })
}

export function addLiveCourseSection(data) {
  return request({
    url: '/livecourse/liveCourseSection/add',
    method: 'post',
    data: data
  })
}

export function updateLiveCourseSection(data) {
  return request({
    url: '/livecourse/liveCourseSection/edit',
    method: 'post',
    data: data
  })
}

export function delLiveCourseSection(data) {
  return request({
    url: '/livecourse/liveCourseSection/delete',
    method: 'post',
    data: data
  })
}

export function createLive(data) {
  return request({
    url: '/livecourse/liveCourseSection/createLive',
    method: 'post',
    data: data
  })
}

export function startLive(data) {
  return request({
    url: '/livecourse/liveCourseSection/startLive',
    method: 'post',
    data: data
  })
}

export function endLive(data) {
  return request({
    url: '/livecourse/liveCourseSection/endLive',
    method: 'post',
    data: data
  })
}

export function getLiveInfo(query) {
  return request({
    url: '/livecourse/liveCourseSection/getLiveInfo',
    method: 'get',
    params: query
  })
}
